export const APP = {
  //  BASE_API_URL: "http://165.232.183.72:4100/v1",

  BASE_API_URL: "https://api.strelasoft.net/smartbulls/mamm/v1",
}
